/**
 * Пак «По-узбекски» — фоны и шаги `state_desktop_*` / `state_mobile_*` в `packs/uzbek/`.
 */
import uzbekBgDesktop from '@/assets/img/rice-game/packs/uzbek/bg-desktop.jpg';
import uzbekBgDesktop2x from '@/assets/img/rice-game/packs/uzbek/bg-desktop@2x.jpg';
import uzbekBgMobile from '@/assets/img/rice-game/packs/uzbek/bg-mobile.jpg';
import uzbekBgMobile2x from '@/assets/img/rice-game/packs/uzbek/bg-mobile@2x.jpg';

import uzbekStateD01 from '@/assets/img/rice-game/packs/uzbek/state_desktop_1.png';
import uzbekStateD02 from '@/assets/img/rice-game/packs/uzbek/state_desktop_2.png';
import uzbekStateD03 from '@/assets/img/rice-game/packs/uzbek/state_desktop_3.png';
import uzbekStateD04 from '@/assets/img/rice-game/packs/uzbek/state_desktop_4.png';
import uzbekStateD05 from '@/assets/img/rice-game/packs/uzbek/state_desktop_5.png';
import uzbekStateD06 from '@/assets/img/rice-game/packs/uzbek/state_desktop_6.png';
import uzbekStateD07 from '@/assets/img/rice-game/packs/uzbek/state_desktop_7.png';
import uzbekStateD08 from '@/assets/img/rice-game/packs/uzbek/state_desktop_8.png';
import uzbekStateD09 from '@/assets/img/rice-game/packs/uzbek/state_desktop_9.png';
import uzbekStateD10 from '@/assets/img/rice-game/packs/uzbek/state_desktop_10.png';
import uzbekStateD11 from '@/assets/img/rice-game/packs/uzbek/state_desktop_11.png';
import uzbekStateD12 from '@/assets/img/rice-game/packs/uzbek/state_desktop_12.png';
import uzbekStateD13 from '@/assets/img/rice-game/packs/uzbek/state_desktop_13.png';
import uzbekStateD14 from '@/assets/img/rice-game/packs/uzbek/state_desktop_14.png';
import uzbekStateD15 from '@/assets/img/rice-game/packs/uzbek/state_desktop_15.png';

import uzbekStateM01 from '@/assets/img/rice-game/packs/uzbek/state_mobile_1.png';
import uzbekStateM02 from '@/assets/img/rice-game/packs/uzbek/state_mobile_2.png';
import uzbekStateM03 from '@/assets/img/rice-game/packs/uzbek/state_mobile_3.png';
import uzbekStateM04 from '@/assets/img/rice-game/packs/uzbek/state_mobile_4.png';
import uzbekStateM05 from '@/assets/img/rice-game/packs/uzbek/state_mobile_5.png';
import uzbekStateM06 from '@/assets/img/rice-game/packs/uzbek/state_mobile_6.png';
import uzbekStateM07 from '@/assets/img/rice-game/packs/uzbek/state_mobile_7.png';
import uzbekStateM08 from '@/assets/img/rice-game/packs/uzbek/state_mobile_8.png';
import uzbekStateM09 from '@/assets/img/rice-game/packs/uzbek/state_mobile_9.png';
import uzbekStateM10 from '@/assets/img/rice-game/packs/uzbek/state_mobile_10.png';
import uzbekStateM11 from '@/assets/img/rice-game/packs/uzbek/state_mobile_11.png';
import uzbekStateM12 from '@/assets/img/rice-game/packs/uzbek/state_mobile_12.png';
import uzbekStateM13 from '@/assets/img/rice-game/packs/uzbek/state_mobile_13.png';
import uzbekStateM14 from '@/assets/img/rice-game/packs/uzbek/state_mobile_14.png';
import uzbekStateM15 from '@/assets/img/rice-game/packs/uzbek/state_mobile_15.png';

export const uzbekBackgrounds = {
  backgroundDesktop: uzbekBgDesktop,
  backgroundDesktop2x: uzbekBgDesktop2x,
  backgroundMobile: uzbekBgMobile,
  backgroundMobile2x: uzbekBgMobile2x,
};

export const uzbekFramesDesktop = [
  uzbekStateD01,
  uzbekStateD02,
  uzbekStateD03,
  uzbekStateD04,
  uzbekStateD05,
  uzbekStateD06,
  uzbekStateD07,
  uzbekStateD08,
  uzbekStateD09,
  uzbekStateD10,
  uzbekStateD11,
  uzbekStateD12,
  uzbekStateD13,
  uzbekStateD14,
  uzbekStateD15,
];

export const uzbekFramesMobile = [
  uzbekStateM01,
  uzbekStateM02,
  uzbekStateM03,
  uzbekStateM04,
  uzbekStateM05,
  uzbekStateM06,
  uzbekStateM07,
  uzbekStateM08,
  uzbekStateM09,
  uzbekStateM10,
  uzbekStateM11,
  uzbekStateM12,
  uzbekStateM13,
  uzbekStateM14,
  uzbekStateM15,
];
